<template>
  <div id="app">
    <router-view slot="router"/>
  </div>
</template>
<script>
export default {
  name: 'App',
  data: () => ({

  }),
}
</script>
